import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';

export type EditorSelectOption = { label: string; value: string };
export type EditorSelectOptions = EditorSelectOption[];

import { commonComponentsRegistry } from '../../../registry/CommonRegistry';

const InputSelectExtended = commonComponentsRegistry.getLazyComponent('InputSelectExtended');

export const EditorInputSelect = ({
    label,
    options = [],
    initialValue,
    required = false,
    handleChange,
}: {
    label: string;
    options: { label: string; value: string }[];
    initialValue?: string;
    required: boolean;
    handleChange: (value: string) => void;
}) => {
    const optionFromInitialValue = useMemo(() => {
        if (initialValue && options.find((el) => el.value === initialValue)) {
            return options.find((el) => el.value === initialValue);
        }

        return options[0];
    }, [initialValue, options]);

    const { control, watch } = useForm({
        defaultValues: { select: optionFromInitialValue },
        criteriaMode: 'all',
    });

    useEffect(() => {
        const subscription = watch((data: any) => {
            handleChange(data.select.value);
        });
        return () => subscription.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watch, handleChange]);

    return (
        <InputSelectExtended
            options={options}
            label={label}
            getValue={(o) => o.value}
            getLabel="label"
            getSearch="label"
            rules={{ required }}
            hideDeleteIcon={true}
            required={required}
            control={control}
            name={'select'}
        />
    );
};
